module.exports = __webpack_public_path__ + "img/concert_hover.5881215c.png";